import React from 'react';
import './home.css'

function initVideo(){
  if(!window.videInitialized){
    
    var bgv = document.getElementById("myVideo");
  
    // what jQuery checks under the hood
    var visible = !!(bgv.offsetWidth ||
      bgv.offsetHeight ||
      bgv.getClientRects().length);
  
    if (visible) {
      var children = bgv.getElementsByTagName("source");
  
      for (var i = 0; i < children.length; ++i) {
  
        children[i].src = children[i].getAttribute("data-init-src");
        let dataSrc = children[i].getAttribute("data-init-src")
        children[i].setAttribute("data-src", dataSrc);
      }
      
      window.videInitialized = true;
      
      bgv.load();
      var playPromise = bgv.play();
    
      if (playPromise !== undefined) {
        playPromise.then(_ => {
          // Automatic playback started!
          // Show playing UI.
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
        });
      }
    }
  }
}

window.addEventListener("load", function() {
  initVideo();
});

window.addEventListener("resize", function() {
    initVideo();
});


export class HomeComponent extends React.Component {
  render() {
    return <div className="section">
              <video className="hide-sm hide-xs" id="myVideo" preload="none" loop muted data-autoplay>
          			<source data-init-src="assets/background_video_raster_low.mp4" type="video/mp4"/>
          		</video>
          		<div className="hide-gt-xs hs-video-placeholder"></div>
          		<div className="hide-xs hide-gt-sm hs-video-placeholder-large"></div>
      	   </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/home.js